module.exports = __webpack_public_path__ + "static/media/hearclearpro-earwax-guard-1.26f32bb5.png";